<template>
    <div
        :id="id"
        class="comment-icon-wrapper"
        :class="{ active: small, 'comment-panel-active': isCommentPanelOpen }">
        <RoundIconButton :title="iconTitle" :class="{ 'btn-sm': small }" @click="$emit('click')">
            <MessagePlusIcon class="text-white" :size="iconSize"/>
        </RoundIconButton>
        <span
            v-if="count"
            class="comment-icon-badge"
            :class="{ 'comment-icon-badge-dot': small }">{{ small ? '' : count }}</span>
    </div>
</template>

<script>
import MessagePlusIcon from '@/common/components/svg-icons/MessagePlusIcon.vue';

export default {
    name: 'CommentIcon',
    props: {
        id: {
            type: String,
            default: null
        },
        count: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        },
        small: {
            type: Boolean,
            default: false
        },
        isCommentPanelOpen: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        iconTitle() {
            return this.title || this.$t('Comment');
        },
        iconSize() {
            return this.small ? '14' : '18';
        }
    },
    components: {
        MessagePlusIcon
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.comment-icon-wrapper {
    position: relative;
    display: inline-flex;

    &.active {
        position: absolute;
        right: 25px;
        top: 0;

        button {
            position: absolute;
            right: -3px;
            top: -3px;
        }
    }

    button {
        position: relative;
        right: 0;
        top: 0;
    }

    .comment-icon-badge {
        position: absolute;
        top: -2px;
        right: -2px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        background-color: $red;
        color: #fff;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        pointer-events: none;
        z-index: 3;

        &-dot {
            top: -2px;
            right: -2px;
            min-width: 8px;
            width: 8px;
            height: 8px;
            padding: 0;
            border-radius: 50%;
        }
    }
}
</style>
